"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrequencyCapToJSON = exports.FrequencyCapFromJSONTyped = exports.FrequencyCapFromJSON = exports.instanceOfFrequencyCap = exports.FrequencyCapFrequencyUnitEnum = void 0;
/**
 * @export
 */
exports.FrequencyCapFrequencyUnitEnum = {
    Day: 'DAY',
    Month: 'MONTH',
    Week: 'WEEK'
};
/**
 * Check if a given object implements the FrequencyCap interface.
 */
function instanceOfFrequencyCap(value) {
    var isInstance = true;
    isInstance = isInstance && "frequencyUnit" in value;
    isInstance = isInstance && "frequencyPeriod" in value;
    isInstance = isInstance && "maxImpressions" in value;
    return isInstance;
}
exports.instanceOfFrequencyCap = instanceOfFrequencyCap;
function FrequencyCapFromJSON(json) {
    return FrequencyCapFromJSONTyped(json, false);
}
exports.FrequencyCapFromJSON = FrequencyCapFromJSON;
function FrequencyCapFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'frequencyUnit': json['frequency_unit'],
        'frequencyPeriod': json['frequency_period'],
        'maxImpressions': json['max_impressions'],
    };
}
exports.FrequencyCapFromJSONTyped = FrequencyCapFromJSONTyped;
function FrequencyCapToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'frequency_unit': value.frequencyUnit,
        'frequency_period': value.frequencyPeriod,
        'max_impressions': value.maxImpressions,
    };
}
exports.FrequencyCapToJSON = FrequencyCapToJSON;
